export var StageQuality;
(function (StageQuality) {
    StageQuality["LOW"] = "low";
    StageQuality["MEDIUM"] = "medium";
    StageQuality["HIGH"] = "high";
    StageQuality["BEST"] = "best";
})(StageQuality || (StageQuality = {}));
